export const DRAFT_DOCUMENT = "app/DocumentDraft/DRAFT_DOCUMENT";
export const DRAFT_DOCUMENT_SUCCESS =
  "app/DocumentDraft/DRAFT_DOCUMENT_SUCCESS";
export const DRAFT_DOCUMENT_FAILURE =
  "app/DocumentDraft/DRAFT_DOCUMENT_FAILURE";
export const CLEAR_DOCUMENT_DRAFT = "app/DocumentDraft/CLEAR_DOCUMENT_DRAFT";

// Conversational co-write (discuss + draft turns)
export const COWRITE = "app/DocumentDraft/COWRITE";
export const COWRITE_SUCCESS = "app/DocumentDraft/COWRITE_SUCCESS";
export const COWRITE_FAILURE = "app/DocumentDraft/COWRITE_FAILURE";

// Evidence search — deterministic (free) picker over resident items NOT already
// in the default draft bundle. Kept separate from COWRITE so a search can't
// cancel an in-flight draft (own takeLatest).
export const EVIDENCE_SEARCH = "app/DocumentDraft/EVIDENCE_SEARCH";
export const EVIDENCE_SEARCH_SUCCESS =
  "app/DocumentDraft/EVIDENCE_SEARCH_SUCCESS";
export const EVIDENCE_SEARCH_FAILURE =
  "app/DocumentDraft/EVIDENCE_SEARCH_FAILURE";

// Evidence detail — deterministic (free) read of a single evidence item's actual
// content, for the panel's per-row detail slide-down. Own takeLatest watcher so a
// detail fetch can't cancel an in-flight draft or search.
export const EVIDENCE_DETAIL = "app/DocumentDraft/EVIDENCE_DETAIL";
export const EVIDENCE_DETAIL_SUCCESS =
  "app/DocumentDraft/EVIDENCE_DETAIL_SUCCESS";
export const EVIDENCE_DETAIL_FAILURE =
  "app/DocumentDraft/EVIDENCE_DETAIL_FAILURE";

// Apply approved co-write schedules & tasks (target='schedule')
export const APPLY_COWRITE = "app/DocumentDraft/APPLY_COWRITE";
export const APPLY_COWRITE_SUCCESS = "app/DocumentDraft/APPLY_COWRITE_SUCCESS";
export const APPLY_COWRITE_FAILURE = "app/DocumentDraft/APPLY_COWRITE_FAILURE";

// Inline "✦ Refine" — light copy-edit of a single field's text
export const REFINE_FIELD = "app/DocumentDraft/REFINE_FIELD";
export const REFINE_FIELD_SUCCESS = "app/DocumentDraft/REFINE_FIELD_SUCCESS";
export const REFINE_FIELD_FAILURE = "app/DocumentDraft/REFINE_FIELD_FAILURE";

// AI authoring history — read-only fetch for the read-mode rail + export
export const FETCH_AUTHORING_HISTORY =
  "app/DocumentDraft/FETCH_AUTHORING_HISTORY";
